module.exports = __webpack_public_path__ + "assets/img/1024_main_img_carousel_1.0344ef65.png";